import React, { FC } from 'react';
import { castDate } from '@factorin/util/lib';
import { Link } from 'react-router-dom';

import { Button2, Stack, Typography, useMobile } from 'Modules/ui3';
import { setHtml } from 'Modules/ui';

import { NewsPaginationElement } from '../../api';


export type NewsPreviewProps = Omit<NewsPaginationElement, 'Img' | 'Tags'>

export const NewsPreview: FC<NewsPreviewProps> =
({ Date, Description, Id, Title }) => {
    const isMobile = useMobile();
    const date = castDate(Date);
    return (
        <Stack spacing={isMobile ? 6 : 8} height='100%' justifyContent='space-between'>
            <Stack spacing={2}>
                <Typography
                    fontFamily='Hauora'
                    fontSize={isMobile ? '12px' : '14px'}
                    fontWeight={500}
                    component='div'
                    lineHeight={isMobile ? '16px' : '20px'}
                    color='#969592'
                >
                    {`${date?.toLocaleString('ru', {
                        day: '2-digit',
                        month: 'long',
                    })} ${date?.getFullYear()}`}
                </Typography>
                <Typography
                    component='div'
                    fontFamily='Hauora'
                    fontSize={isMobile ? '16px' : '20px'}
                    fontWeight={700}
                    lineHeight={isMobile ? '24px' : '32px'}
                    color='#1E2127'
                    display='-webkit-box'
                    maxHeight={isMobile ? '48px' : '64px'}
                    textOverflow='ellipsis'
                    overflow='hidden'
                    title={Title}
                    sx={{
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                    }}
                    {...setHtml(Title)}
                />
                <Typography
                    component='div'
                    display='-webkit-box'
                    fontFamily='Hauora'
                    fontSize={isMobile ? '14px' : '16px'}
                    lineHeight={isMobile ? '20px' : '24px'}
                    fontWeight={500}
                    maxHeight={isMobile ? '60px' : '72px'}
                    textOverflow='ellipsis'
                    overflow='hidden'
                    color='#969592'
                    sx={{
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                    }}
                    {...setHtml(Description)}
                />
            </Stack>
            <Button2
                // @ts-ignore
                component={Link}
                variant='secondary'
                to={`/news/${Id}`}
                size={isMobile ? 'medium' : 'large'}
                sx={{
                    fontSize: '16px',
                    lineHeight: '24px',
                    fontFamily: 'Hauora',
                    fontWeight: 700,
                    color: '#242424',
                    borderRadius: 5,
                    '&:hover': {
                        color: '#242424',
                        bgcolor: '#E6E6E6',
                    },
                    '&:focus, &:active': {
                        color: '#242424',
                        bgcolor: '#DBDBDB',
                    },
                }}
            >
                Читать
            </Button2>
        </Stack>
    );
};
